import React from "react";
import { Box, Typography, Container, Fade } from "@mui/material";
import "../../styles/components/AboutHeroSection.css";

function HeroSection() {
  return (
    <section className="about-hero-section-wrapper">
      <Container>
        <Fade in timeout={1000}>
          <Box textAlign="center">
            <Typography
              variant="h1"
              component="h1"
              gutterBottom
              sx={{
                fontSize: { xs: "2.5rem", md: "3.5rem" },
                fontWeight: 700,
                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
              }}
            >
              About
            </Typography>
            <Typography
              variant="h5"
              sx={{
                opacity: 0.9,
                maxWidth: "600px",
                margin: "0 auto",
                lineHeight: 1.6,
              }}
            >
              Application Developer crafting innovative solutions.
            </Typography>
          </Box>
        </Fade>
      </Container>
    </section>
  );
}

export default HeroSection;
